import React, { useEffect, useState } from 'react';
import { Modal } from 'src/ui/Modal';
import { Button } from 'src/ui/Button';
import { Textarea } from 'src/ui/Textarea';
import saveAs from 'file-saver';
import { json2csv } from 'json-2-csv';

const ProfileModal = ({
  isModalOpen = false,
  onModalClose = () => null,
  user = null,
  optionsMap = {},
}: {
  isModalOpen: boolean;
  onModalClose: any;
  user: any;
  optionsMap: any;
}) => {
  const [profile, setProfile] = useState<any>(null);

  useEffect(() => {
    if (!user || !user.profile) {
      return;
    }

    let result = {} as any;
    Object.keys(user.profile).forEach((key: any) => {
      if (
        ['id', 'userId', 'createdAt', 'updatedAt', 'answers'].indexOf(key) !==
        -1
      ) {
        return null;
      }
      const value = user.profile?.[key] || '';
      if (optionsMap[key]) {
        const options = optionsMap[key].labels;
        const isBinary = options[1]?.[0] <= 2;
        if (isBinary) {
          result[key] = options
            .reduce((acc: any, cur: any) => {
              if (Number(value) & Math.pow(2, cur[0])) {
                acc.push(cur[1].cn);
              }
              return acc;
            }, [])
            .join(', ');
        } else {
          result[key] = options.find(
            (option: any) => option[0] === value
          )?.[1].cn;
        }
      } else {
        result[key] = value;
      }
    });

    if (user.profile.answers) {
      result = { ...result, ...user.profile.answers };
    }
    setProfile(result);
  }, [user, optionsMap]);

  const onDownload = () => {
    if (!user || !profile) {
      return;
    }

    const blob = new Blob(
      [
        json2csv(
          Object.keys(profile).map((key) => [key, profile[key]]),
          { prependHeader: false }
        ),
      ],
      {
        type: 'text/csv;charset=utf-8',
      }
    );
    saveAs(blob, `${user?.email}.csv`);
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={onModalClose}
      title={user?.email}
      width={700}
      footer={
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant="primary" onClick={onDownload} style={{ width: 300 }}>
            Download CSV
          </Button>
        </div>
      }
    >
      <Textarea
        readOnly
        value={JSON.stringify(profile, null, 2)}
        style={{ minHeight: 500, width: '100%' }}
      />
    </Modal>
  );
};

export default ProfileModal;
